import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addCandidateProfile, addCandidateResume, fetchBasicDetails, updateCandidateDetails } from "./BasicDetailsAPI";

const initialState = {
  value: 0,
  status: "idle",
  basicDetail: {},
  profile: [],
  resume: [],
};

export const fetchBasicDetailsAsync = createAsyncThunk(
  "candidate/fetch",
  async () => {
    const response = await fetchBasicDetails();
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const updateCandidateDetailsAsync = createAsyncThunk(
  "candidate/update",
  async ({ uuid, candidateData }) => {
    try {
      const response = await updateCandidateDetails(uuid, candidateData);
      // console.log("Saved data", candidateData);
      return response;
    } catch (error) {
      // return rejectWithValue(error.message);
    }
  }
);

export const addCandidateProfileAsync = createAsyncThunk(
  "CandidateProfile/upload",
  async ({ formData }, { rejectWithValue }) => {
    try {
      const result = await addCandidateProfile(formData);
      // console.log("result in slice", result)
      return result;
    } catch (error) {
      return rejectWithValue(error.message); // If error occurs, return the error message
    }
  }
);
export const addCandidateResumeAsync = createAsyncThunk(
  "CandidateResume/upload",
  async ({ formData }, { rejectWithValue }) => {
    try {
      const result = await addCandidateResume(formData);

      return result;
    } catch (error) {
      return rejectWithValue(error.message); // If error occurs, return the error message
    }
  }
);

const candDashBasicDetails = createSlice({
  name: "candidateProfile/basicDetails",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchBasicDetailsAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBasicDetailsAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.basicDetail = action.payload;
      })

      .addCase(addCandidateProfileAsync.fulfilled, (state, action) => {
        state.profile.push(action.payload);
        console.log("state.data", state.data)
      })
      .addCase(addCandidateProfileAsync.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(addCandidateResumeAsync.fulfilled, (state, action) => {
        state.resume.push(action.payload);
      })
      .addCase(addCandidateResumeAsync.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(updateCandidateDetailsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCandidateDetailsAsync.fulfilled, (state, action) => {
        state.loading = false;

        if (Array.isArray(state.data)) {
          const updatedDetailsIndex = state.data.findIndex(
            (candidateData) => candidateData.uuid === action.payload.uuid
          );

          if (updatedDetailsIndex !== -1) {
            state.data[updatedDetailsIndex] = action.payload;
          }
        } else {
          state.data = [action.payload];
        }
      })

      .addCase(updateCandidateDetailsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to update project";
      });
  },
});

export const selectBasicDetails = (state) =>
  state.candProfileBasicDetails.basicDetail;

export default candDashBasicDetails.reducer;






// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { addCandidateProfile, addCandidateResume, fetchBasicDetails, updateCandidateDetails } from "./BasicDetailsAPI";

// const initialState = {
//   status: "idle",
//   loading: false,
//   basicDetail: null,
//   profile: null,
//   resume: null,
//   error: null,
//   lastUpdated: null,
// };

// // Throttle configuration
// const THROTTLE_INTERVAL = 1000; // 1 second between similar requests
// const activeRequests = {};

// export const fetchBasicDetailsAsync = createAsyncThunk(
//   "candidate/fetch",
//   async (_, { rejectWithValue }) => {
//     const requestKey = 'fetchBasicDetails';

//     // Check if there's an active request of this type
//     if (activeRequests[requestKey]) {
//       return activeRequests[requestKey];
//     }

//     try {
//       const promise = fetchBasicDetails();
//       activeRequests[requestKey] = promise;

//       const response = await promise;
//       delete activeRequests[requestKey];
//       return response;
//     } catch (error) {
//       delete activeRequests[requestKey];
//       return rejectWithValue(error.message);
//     }
//   }
// );

// export const updateCandidateDetailsAsync = createAsyncThunk(
//   "candidate/update",
//   async ({ uuid, candidateData }, { rejectWithValue }) => {
//     const requestKey = `updateCandidate-${uuid}`;

//     if (activeRequests[requestKey]) {
//       return activeRequests[requestKey];
//     }

//     try {
//       const promise = updateCandidateDetails(uuid, candidateData);
//       activeRequests[requestKey] = promise;

//       const response = await promise;
//       delete activeRequests[requestKey];
//       return response;
//     } catch (error) {
//       delete activeRequests[requestKey];
//       return rejectWithValue(error.message);
//     }
//   }
// );

// export const addCandidateProfileAsync = createAsyncThunk(
//   "CandidateProfile/upload",
//   async ({ formData }, { rejectWithValue }) => {
//     try {
//       return await addCandidateProfile(formData);
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// export const addCandidateResumeAsync = createAsyncThunk(
//   "CandidateResume/upload",
//   async ({ formData }, { rejectWithValue }) => {
//     try {
//       return await addCandidateResume(formData);
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// const candDashBasicDetails = createSlice({
//   name: "candidateProfile/basicDetails",
//   initialState,
//   reducers: {
//     resetError: (state) => {
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       // Fetch Basic Details
//       .addCase(fetchBasicDetailsAsync.pending, (state) => {
//         state.status = "loading";
//         state.error = null;
//       })
//       .addCase(fetchBasicDetailsAsync.fulfilled, (state, action) => {
//         state.status = "idle";
//         state.basicDetail = action.payload;
//         state.lastUpdated = Date.now();
//       })
//       .addCase(fetchBasicDetailsAsync.rejected, (state, action) => {
//         state.status = "idle";
//         state.error = action.payload;
//       })

//       // Update Candidate Details
//       .addCase(updateCandidateDetailsAsync.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(updateCandidateDetailsAsync.fulfilled, (state, action) => {
//         state.loading = false;
//         state.basicDetail = { ...state.basicDetail, ...action.payload };
//         state.lastUpdated = Date.now();
//       })
//       .addCase(updateCandidateDetailsAsync.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })

//       // Add Profile Photo
//       .addCase(addCandidateProfileAsync.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(addCandidateProfileAsync.fulfilled, (state, action) => {
//         state.loading = false;
//         state.profile = action.payload;
//         state.lastUpdated = Date.now();
//       })
//       .addCase(addCandidateProfileAsync.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })

//       // Add Resume
//       .addCase(addCandidateResumeAsync.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(addCandidateResumeAsync.fulfilled, (state, action) => {
//         state.loading = false;
//         state.resume = action.payload;
//         state.lastUpdated = Date.now();
//       })
//       .addCase(addCandidateResumeAsync.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const { resetError } = candDashBasicDetails.actions;
// export const selectBasicDetails = (state) => state.candProfileBasicDetails.basicDetail;
// export const selectProfileStatus = (state) => state.candProfileBasicDetails.status;
// export const selectLastUpdated = (state) => state.candProfileBasicDetails.lastUpdated;

// export default candDashBasicDetails.reducer;